import { gql } from 'graphql-tag';

export const SET_SUPPLIER_ACCOUNT_TO_SUPPLIER = gql`
  mutation Id76028a0948f94d95332c3959d379c3be(
    $companyId: ID!
    $supplierId: ID!
    $supplierAccountId: String!
  ) {
    __typename
  }
`;
